import { HANDLE_DIESEL, RESET } from '../actions';
import moment from 'moment';

const initialState = {
    diesel: [],
    vehicleFilter: "",
    startDateFilter: moment().format("YYYY-MM-DD"),
    endDateFilter: moment().format("YYYY-MM-DD"),
    sortFilter: "desc"
};

const Diesel = (state = initialState, action) => {
    
    switch (action.type) {
        case HANDLE_DIESEL:
            return {
                ...state,
                ...action.data
            };
        case RESET:
            return initialState
        default:
            return state;
    }
};

export default Diesel;